(function () {
  var DATA_URL = window.TC_GUIA_DATA_URL;
  var ICONS = window.TC_GC_ICONS || {};
  var DATA = null;

  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function fetchData() {
    if (DATA) return Promise.resolve(DATA);
    return fetch(DATA_URL).then(function (r) { return r.json(); }).then(function (d) { DATA = d; return d; });
  }

  var ACCENTS = { IPA: '#4E8B31', ALE: '#C55A11', SOUR: '#BF8F00', BLACK: '#4A4A4A', LAGER: '#2F5597' };
  var FAM_LABEL = { IPA: 'IPA', ALE: 'Ale', SOUR: 'Sour & Ácidas', BLACK: 'Oscuras & Stouts', LAGER: 'Lager' };

  function cardHTML(e, accent, isComparing, compareFull) {
    var disabled = !isComparing && compareFull;
    return '<div class="gc-card" style="border-top-color:' + accent + '" data-gc-card="' + e.h + '">' +
      '<a href="/pages/estilos-de-cervezas/' + e.h + '">' +
      '<b>' + escapeHtml(e.n) + '</b>' +
      '<span>' + escapeHtml(e.sf || '') + ' · ' + escapeHtml(e.e || '') + '</span>' +
      '<span>' + e.am + '–' + e.ax + '% ABV · ' + e.im + '–' + e.ix + ' IBU</span>' +
      '</a>' +
      '<button type="button" class="gcf-card-add' + (isComparing ? ' is-on' : '') + '" data-gc-add="' + e.h + '"' +
      (disabled ? ' disabled' : '') + '>' +
      (isComparing ? '✓ En comparación' : '+ Comparar') +
      '</button>' +
      '</div>';
  }

  var root = document.querySelector('[data-gc-root]');
  if (!root) return;

  var grid = root.querySelector('[data-gc-grid]');
  var countEl = root.querySelector('[data-gc-count]');
  var hintEl = root.querySelector('[data-gc-hint]');
  var famChips = root.querySelectorAll('[data-gc-familia]');
  var srmMin = root.querySelector('[data-gc-srm-min]');
  var srmMax = root.querySelector('[data-gc-srm-max]');
  var abvMin = root.querySelector('[data-gc-abv-min]');
  var abvMax = root.querySelector('[data-gc-abv-max]');
  var ibuMin = root.querySelector('[data-gc-ibu-min]');
  var ibuMax = root.querySelector('[data-gc-ibu-max]');
  var escuelaSel = root.querySelector('[data-gc-escuela]');
  var searchInput = root.querySelector('[data-gc-search]');
  var sortSel = root.querySelector('[data-gc-sort]');
  var compareWrap = root.querySelector('[data-gc-compare-wrap]');
  var compareTbl = root.querySelector('[data-gc-compare-table]');

  var activeFamilias = {};
  famChips.forEach(function (chip) { activeFamilias[chip.getAttribute('data-gc-familia')] = true; });

  var compareSet = []; // array of handles, order = selection order, max 5
  var lastItems = [];

  famChips.forEach(function (chip) {
    chip.addEventListener('click', function () {
      var fam = chip.getAttribute('data-gc-familia');
      if (activeFamilias[fam]) { delete activeFamilias[fam]; chip.classList.remove('is-active'); }
      else { activeFamilias[fam] = true; chip.classList.add('is-active'); }
      render();
    });
  });
  [srmMin, srmMax, abvMin, abvMax, ibuMin, ibuMax, escuelaSel, searchInput, sortSel].forEach(function (el) {
    if (el) el.addEventListener('input', render);
  });

  grid.addEventListener('click', function (evt) {
    var btn = evt.target.closest('[data-gc-add]');
    if (!btn) return;
    var handle = btn.getAttribute('data-gc-add');
    toggleCompare(handle);
  });

  function toggleCompare(handle) {
    var idx = compareSet.indexOf(handle);
    if (idx !== -1) {
      compareSet.splice(idx, 1);
    } else {
      if (compareSet.length >= 5) return;
      compareSet.push(handle);
    }
    renderCards();
    renderCompare();
  }

  function renderCards() {
    var accent;
    grid.innerHTML = lastItems.map(function (e) {
      accent = ACCENTS[e.f] || '#111';
      return cardHTML(e, accent, compareSet.indexOf(e.h) !== -1, compareSet.length >= 5);
    }).join('') || '<p style="font-size:12px;color:var(--gris);">No hay estilos con estos filtros.</p>';
    if (countEl) countEl.textContent = lastItems.length;
  }

  function row(iconKey, label, valueFn) {
    return { icon: ICONS[iconKey] || '', label: label, valueFn: valueFn };
  }

  var ROWS = [
    row('familia', 'Familia', function (e) {
      return '<span style="display:inline-block;padding:2px 7px;font-family:\'Space Mono\',monospace;font-size:9px;' +
        'font-weight:700;letter-spacing:.05em;color:#fff;background:' + (ACCENTS[e.f] || '#111') + '">' +
        escapeHtml(FAM_LABEL[e.f] || e.f) + '</span>' + (e.sf ? ' <span style="color:var(--gris);font-size:11px;">' + escapeHtml(e.sf) + '</span>' : '');
    }),
    row('escuela', 'Escuela', function (e) { return escapeHtml(e.e || '—'); }),
    row('origen', 'País', function (e) { return escapeHtml(e.p || '—'); }),
    row('color', 'Color (SRM)', function (e) { return e.sm + '–' + e.sx + ' SRM'; }),
    row('alcohol', 'Alcohol (ABV)', function (e) { return e.am + '–' + e.ax + '% ABV'; }),
    row('amargor', 'Amargor (IBU)', function (e) { return e.im + '–' + e.ix + ' IBU'; }),
    row('cuerpo', 'Cuerpo', function (e) { return escapeHtml(e.cu || '—'); }),
    row('aroma', 'Aroma', function (e) { return escapeHtml(e.ar || '—'); }),
    row('sabor', 'Sabor', function (e) { return escapeHtml(e.sa || '—'); })
  ];

  function renderCompare() {
    if (compareSet.length < 2) {
      compareWrap.classList.remove('is-active');
      compareTbl.innerHTML = '';
      if (hintEl) hintEl.textContent = compareSet.length === 1
        ? 'Elige al menos 1 estilo más para comparar (máx. 5).'
        : 'Elige hasta 5 estilos para compararlos lado a lado.';
      return;
    }
    if (hintEl) hintEl.textContent = compareSet.length + ' de 5 estilos en comparación.';
    compareWrap.classList.add('is-active');
    fetchData().then(function (data) {
      var byHandle = {};
      data.forEach(function (e) { byHandle[e.h] = e; });
      var chosen = compareSet.map(function (h) { return byHandle[h]; }).filter(Boolean);

      var thead = '<tr><th class="gc-attr-col"></th>' + chosen.map(function (e) {
        var accent = ACCENTS[e.f] || '#111';
        return '<th style="background:' + accent + '">' +
          '<a class="gc-remove" href="#" data-gc-remove="' + e.h + '" aria-label="Quitar ' + escapeHtml(e.n) + '">×</a>' +
          '<span class="gc-th-name">' + escapeHtml(e.n) + '</span>' +
          '<span class="gc-th-link"><a href="/pages/estilos-de-cervezas/' + e.h + '">Ver ficha completa →</a></span>' +
          '</th>';
      }).join('') + '</tr>';

      var tbody = ROWS.map(function (r) {
        return '<tr><th>' + r.icon + r.label + '</th>' +
          chosen.map(function (e) { return '<td>' + r.valueFn(e) + '</td>'; }).join('') + '</tr>';
      }).join('');

      compareTbl.innerHTML = '<div class="gc-compare-scroll"><table class="gc-compare-tbl"><thead>' + thead +
        '</thead><tbody>' + tbody + '</tbody></table></div>';

      compareTbl.querySelectorAll('[data-gc-remove]').forEach(function (a) {
        a.addEventListener('click', function (evt) {
          evt.preventDefault();
          toggleCompare(a.getAttribute('data-gc-remove'));
        });
      });
    });
  }

  function render() {
    fetchData().then(function (data) {
      var items = data.filter(function (e) { return activeFamilias[e.f]; });
      var sMin = parseFloat(srmMin.value); if (isNaN(sMin)) sMin = 0;
      var sMax = parseFloat(srmMax.value); if (isNaN(sMax)) sMax = 999;
      var aMin = parseFloat(abvMin.value); if (isNaN(aMin)) aMin = 0;
      var aMax = parseFloat(abvMax.value); if (isNaN(aMax)) aMax = 999;
      var iMin = parseFloat(ibuMin.value); if (isNaN(iMin)) iMin = 0;
      var iMax = parseFloat(ibuMax.value); if (isNaN(iMax)) iMax = 999;
      items = items.filter(function (e) {
        return e.sx >= sMin && e.sm <= sMax &&
          e.ax >= aMin && e.am <= aMax &&
          e.ix >= iMin && e.im <= iMax;
      });
      var esc = escuelaSel.value;
      if (esc) items = items.filter(function (e) { return e.e === esc; });
      var q = (searchInput.value || '').trim().toLowerCase();
      if (q) items = items.filter(function (e) {
        return e.n.toLowerCase().indexOf(q) !== -1 || (e.sf || '').toLowerCase().indexOf(q) !== -1;
      });
      var sort = sortSel.value;
      if (sort === 'abv') items.sort(function (a, b) { return a.am - b.am; });
      else if (sort === 'ibu') items.sort(function (a, b) { return a.im - b.im; });
      else items.sort(function (a, b) { return a.n.localeCompare(b.n, 'es'); });
      lastItems = items;
      renderCards();
    });
  }

  render();
  renderCompare();
})();
